import './style.css';
const Background = ({theme})=>{
    return (
        <>
            <div className='header'>
                <picture>
                <source media="(max-width:375px)" srcSet="./images/bg-mobile-dark.jpg"/>
                <img src={ "./images/bg-desktop-"+theme+".jpg"} alt="Background"/>
                </picture>
            </div>
            <div className={theme+'Body'}>
            </div>
        </>
    )
}
export default Background;